<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('packageDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/' + this.$route.params.id + '/selection/' + this.$route.params.selectionId">
                        {{ data.name || $t('selection') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ selectionPackageName }}</li>
            </ol>
        </nav>
        <div v-for="(selectionPackage, i) in getCurrentPackage()" :key="i" class="row">
            <div class="mb-3" >
                <div class="row">
                    <div class="mb-3 col-md-4">
                        <label class="form-label" for="name" required>{{ $t('name') }}</label>
                        <input v-model="selectionPackage.name" type="text" class="form-control" id="name" >
                    </div>
                    <!-- <div class="mb-3 col-md-4">
                        <label class="form-label" for="inputMethod" required>{{ $t('inputMethod') }}</label>
                        <select v-model="selectionPackage.inputMethod"  class="form-select" id="inputMethod" >
                            <option value="custom">{{ $t('custom') }}</option>
                            <option value="yearly">{{ $t('yearly') }}</option>
                            <option value="divided">{{ $t('divided') }}</option>
                        </select>
                    </div>
                    <div class="mb-3 col-md-5">
                        <div class="form-check">
                            <input class="form-check-input" v-model="selectionPackage.unlimited" type="checkbox" id="unlimited">
                            <label class="form-check-label" for="unlimited">
                                {{ $t('unlimited') }}
                            </label>
                        </div>
                    </div> -->
                </div>
                <h4 class="form-label" for="costFactor" required>{{ $t('packageLifeCycleViewModel') }}</h4>
                <div class="row">
                    <div class="mb-3 col-md-12">
                        <div class="row">
                           <div class="col-md-1">
                                <input class="form-check-input" @click="checkAllPackageLifeCycles($event)" :checked="areAllLifeCyclesChecked()" type="checkbox" :id="'checked_' + o">
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('area') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('assetType') }}</label>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">{{ $t('lifeCycle') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('benefit') }}</label>
                            </div>
                            <div class="col-md-2">
                                <label class="form-label">{{ $t('benefitWeight') }}</label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3 col-md-12" v-for="(packageLifeCycle, o) in packageLifeCycleViewModel" :key="o">
                        <div class="row">
                            <div class="col-md-1">
                                <input class="form-check-input" v-model="packageLifeCycle.checked" type="checkbox" :id="'checked_' + o">
                            </div>
                            <div class="col-md-2">
                                <select class="form-select" v-model="packageLifeCycle.selectionGroupId" disabled :id="'selectionGroupId' + o ">
                                    <option v-for="(group,u) in data.selectionGroup" :key="u" v-bind:value="group.id">{{group.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <select v-model="packageLifeCycle.assetTypeId" disabled class="form-select" :id="'assetType' + o"> 
                                    <option v-for="(assetType,u) in assetTypes" :key="u" v-bind:value="assetType.id">{{assetType.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <select v-model="packageLifeCycle.lifeCycleId" disabled class="form-select" :id="'lifeCycle' + o"> 
                                    <option v-for="(lifeCycle,u) in lifeCycles" :key="u" v-bind:value="lifeCycle.id">{{lifeCycle.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <select class="form-select" v-model="packageLifeCycle.benefitId" :disabled="!packageLifeCycle.checked" :id="'benefitId' + o ">
                                    <option value="">{{ $t('select')}} </option>
                                    <option v-for="(benefit,u) in filteredBenefits(packageLifeCycle.assetTypeId)" :key="u" v-bind:value="benefit.id">{{benefit.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <input v-model="packageLifeCycle.benefitWeight" :disabled="!packageLifeCycle.checked" max="1" class="form-control" :id="'benefitWeight_' + o" type="number" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
        <div class="d-grid gap-2 d-md-flex">
            <template v-if="isUserAdmin">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
                <button type="button" class="btn btn-danger" @click="showSelectionPackageDeleteModal = true">{{ $t('delete') }}</button>
            </template>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}` })">{{ $t('back') }}</button>
        </div>
        <SelectionPackageDeleteModal v-if="showSelectionPackageDeleteModal" @reload="confirmPackageDelete()" @closeDeleteDialog="showSelectionPackageDeleteModal = false"/>
    </div>
</template>

<script>
import SelectionApi from "../../../api/server/selection";
import ForecastApi from "../../../api/server/forecast";
import ModelingApi from "../../../api/server/modeling";
import AssetTypeApi from '../../../api/server/assetType';
import BenefitApi from '../../../api/server/benefit';
import LifeCycleApi from '../../../api/server/lifeCycle';
import SelectionPackageDeleteModal from "./SelectionPackageDeleteModal.vue";
import { CheckIfUserIsEditor } from '../../../authCache';

export default {
    name: "selectionpackage",
    watch: {
        $route: "requestData",
    },
    components: {
        SelectionPackageDeleteModal
    },
    mounted() {
        this.requestData();
    },
    methods: {
        areAllLifeCyclesChecked() {
            return this.packageLifeCycleViewModel.filter(l => !l.checked).length == -1;
        },
        checkAllPackageLifeCycles(event) {
            for(var i in this.packageLifeCycleViewModel) {
                var lifeCycle = this.packageLifeCycleViewModel[i];
                lifeCycle.checked = event.target.checked;
            }
        },
        async confirmPackageDelete() {
            this.pending = true;
            this.data.selectionPackage = this.data.selectionPackage.filter(l => l.id != this.$route.params.packageId);
            await SelectionApi.selectionUpdate(this.$route.params.id, this.data);
            this.$router.push({ path: `/modeling/${this.$route.params.id}/selection/${this.$route.params.selectionId}` });
        },
        filteredBenefits(assetTypeId) {
            return this.benefits.filter(b => b.assetTypeId == assetTypeId);
        },
        getCurrentPackage() {
            var selectionPackage = this.data.selectionPackage.filter(g => g.id == this.$route.params.packageId);
            if(selectionPackage.length > 0) {
                this.selectionPackageName = selectionPackage[0].name;
                return selectionPackage;
            } 
        },
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsEditor();

            var selectionId = this.$route.params.selectionId;
            this.data = await SelectionApi.selectionDetail(this.$route.params.id, selectionId);
            var forecast = await ForecastApi.forecastDetail(this.$route.params.id, this.data.forecastId);
            var currentPackage = this.data.selectionPackage.find(g => g.id == this.$route.params.packageId);


            this.assetTypes = await AssetTypeApi.assetTypeList(this.$route.params.id);
            this.lifeCycles = await LifeCycleApi.lifeCycleList(this.$route.params.id);

            var packageLifeCycleViewModel = [];

            this.benefits = await BenefitApi.benefitList(this.$route.params.id);


            for (var i in this.data.selectionGroup) {
                var group = this.data.selectionGroup[i];
                
                var groupMultiplicatorForecast = [];

                // group multiplicator = LC - forecast 
                for (var o in forecast.forecastAssetTypes) {
                    var assetType = forecast.forecastAssetTypes[o];
                    // ignore not in groups
                    if(group.selectionGroupAssetType.length > 0) {
                        if(group.selectionGroupAssetType.findIndex(a => a.assetTypeId == assetType.assetTypeId) == -1) {
                            continue
                        }
                    } 
                    for (var u in assetType.lifeCycles) {
                        var lifeCycleId = assetType.lifeCycles[u];
                        groupMultiplicatorForecast.push({ assetTypeId: assetType.assetTypeId, lifeCycleId  })
                    }
                }

                // for each AT and LC = GROUP
                for(var o in groupMultiplicatorForecast) {
                    var object = groupMultiplicatorForecast[o];

                    var assetTypeBenefit = this.benefits.find(b => b.assetTypeId == object.assetTypeId);

                    var packageLifeCycleViewModelObject = {
                        benefitId: assetTypeBenefit?.id,
                        benefitWeight: 1,
                        checked: false,
                        selectionPackageId: this.$route.params.packageId,
                        assetTypeId: object.assetTypeId,
                        lifeCycleId: object.lifeCycleId,
                        name: group.name,
                        selectionGroupId: group.id
                    }

                    var foundSelectionPackageLifeCycle = currentPackage?.selectionPackageLifeCycle?.find(v => v.selectionGroupId == group.id && v.lifeCycleId == object.lifeCycleId);
                    if(foundSelectionPackageLifeCycle) {
                        // TODO prepsani modelu
                        packageLifeCycleViewModelObject.benefitId = foundSelectionPackageLifeCycle.benefitId;
                        packageLifeCycleViewModelObject.benefitWeight = foundSelectionPackageLifeCycle.benefitWeight;
                        packageLifeCycleViewModelObject.id = foundSelectionPackageLifeCycle.id,
                        packageLifeCycleViewModelObject.checked = true,
                        packageLifeCycleViewModelObject.selectionPackageId = foundSelectionPackageLifeCycle.id,
                        packageLifeCycleViewModelObject.assetTypeId =object.assetTypeId,
                        packageLifeCycleViewModelObject.lifeCycleId = object.lifeCycleId,
                        packageLifeCycleViewModelObject.name = group.name,
                        packageLifeCycleViewModelObject.selectionGroupId = group.id
                    }
                    
                    packageLifeCycleViewModel.push(packageLifeCycleViewModelObject);
                }
            }
            
            this.packageLifeCycleViewModel = packageLifeCycleViewModel;


            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            
            this.pending = false;
        },
        async onSubmit() {
            var selectionPackage = this.data.selectionPackage.find(g => g.id == this.$route.params.packageId);
            if(selectionPackage.name.length > 0) {
                try {
                    var selectionPackageLifeCycles = [];
                    for(var i in this.packageLifeCycleViewModel) {
                        var packageLifeCycle = this.packageLifeCycleViewModel[i];
                        if(packageLifeCycle.checked) {
                            selectionPackageLifeCycles.push({
                                "id": packageLifeCycle.id || 0,
                                "selectionPackageId": packageLifeCycle.selectionPackageId,
                                "selectionGroupId": packageLifeCycle.selectionGroupId,
                                "lifeCycleId": packageLifeCycle.lifeCycleId,
                                "benefitId": packageLifeCycle.benefitId,
                                "benefitWeight": packageLifeCycle.benefitWeight
                            })
                        }
                    }
                    selectionPackage.selectionPackageLifeCycle = selectionPackageLifeCycles;
                    
                    await SelectionApi.selectionUpdate(this.$route.params.id, this.data);
                    this.showSuccess();
                } catch {
                    this.showError();
                }
            } else {
                this.showEmptyNameError();
            }
        }
    },
    notifications: {
        showEmptyNameError: {
            title: 'error',
            message: 'emptyName',
            type: 'error'
        },
        showSuccess: {
            title: 'success',
            message: 'selectionPackageUpdated',
            type: 'success'
        },
        showError: {
            title: 'error',
            message: 'selectionPackageErrorUpdate',
            type: 'error'
        }
    },
    data() {
        return {
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                selectionGroups: [],
                selectionPackage: [],
                selectionLimit: []
            },
            selectionPackageName: "",
            assetTypes: [],
            lifeCycles: [],
            benefits: [],
            pending: true,
            modelingName: "",
            showSelectionPackageDeleteModal: false,
            packageLifeCycleViewModel: [],
            isUserAdmin: false
        }
    }
};
</script>